import React from 'react';
import type { OrderStatusPreviewContentProps } from './types';
import OrderStatusUpdateTable from './OrderStatusUpdateTable';

const OrderStatusPreviewContent: React.FC<OrderStatusPreviewContentProps> = ({
  data,
  brand,
  isCollapsed = false,
  onToggleCollapse,
}) => {
  const emailRecipientsText = data.emailRecipients?.join(', ') || '';

  return (
    <div
      className="rounded-lg shadow-lg overflow-hidden"
      style={{
        backgroundColor: 'white',
        border: `1px solid ${brand.colors.border}`,
        minWidth: '700px',
        maxWidth: '900px',
      }}
    >
      {/* Header */}
      <div
        className="px-4 py-2 flex items-center justify-between cursor-pointer"
        style={{ backgroundColor: brand.colors.bgLight }}
        role="button"
        tabIndex={0}
        onClick={onToggleCollapse}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onToggleCollapse(); } }}
      >
        <div className="flex items-center gap-2">
          <span
            className="text-sm font-semibold"
            style={{ color: brand.colors.secondary }}
          >
            Status Updates
          </span>
          <svg
            className="w-4 h-4 transition-transform"
            style={{
              color: brand.colors.textLight,
              transform: isCollapsed ? 'rotate(-90deg)' : 'rotate(0deg)',
            }}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>

      {!isCollapsed && (
        <>
          {/* Action bar */}
          <div
            className="px-4 py-2 flex items-center justify-between border-b"
            style={{ borderColor: brand.colors.border }}
          >
            <button
              className="px-3 py-1.5 text-xs font-medium rounded border"
              style={{
                borderColor: brand.colors.primary,
                color: brand.colors.link,
                backgroundColor: 'white',
              }}
            >
              Add Status Update
            </button>
            {emailRecipientsText && (
              <span
                className="text-xs"
                style={{ color: brand.colors.textLight }}
              >
                Email will be sent to: <span style={{ color: brand.colors.text }}>{emailRecipientsText}</span>
              </span>
            )}
          </div>

          {/* Table */}
          <OrderStatusUpdateTable updates={data.updates} brand={brand} />
        </>
      )}
    </div>
  );
};

export default OrderStatusPreviewContent;
